import { call, put, takeLatest } from 'redux-saga/effects';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import {
  getClientDetailsService,
  getClientListService,
  getPolicyListForClientService,
  updateNoteService,
} from '@services/client/client.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import {
  setClientDetailDataAction,
  setClientslistDataAction,
  setPolicyListForClientAction,
} from '@stores/client/action.js';
import {
  GET_CLIENT_DETAIL_DATA,
  GET_CLIENT_DETAILS_PAGINATOR,
  GET_CLIENT_LIST_DATA,
  SET_NOTE_CLIENT_DATA,
} from '@stores/client/constans.js';

export function* getClientListData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getClientListService, payload);
    yield put(loadingSuccess());
    yield put(setClientslistDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export function* setClientNoteData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(updateNoteService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export function* getClientDetailData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getClientDetailsService, payload);
    yield put(loadingSuccess());
    yield put(setClientDetailDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export function* getPolicyListForClientData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPolicyListForClientService, payload);
    yield put(loadingSuccess());
    yield put(setPolicyListForClientAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export default function* clientSaga() {
  yield takeLatest(GET_CLIENT_LIST_DATA, getClientListData);
  yield takeLatest(SET_NOTE_CLIENT_DATA, setClientNoteData);
  yield takeLatest(GET_CLIENT_DETAIL_DATA, getClientDetailData);
  yield takeLatest(GET_CLIENT_DETAILS_PAGINATOR, getPolicyListForClientData);
}
